import {Box, SxProps, Theme} from '@mui/material';

interface ITabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: SxProps<Theme>;
}
const TabPanel = (props: ITabPanelProps) => {
  const {children, value, index, sx, ...other} = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`tabpanel-${index}`} {...other}>
      {value === index && (
        <Box sx={{p: 2, pt: 4, pb: 1, bgcolor: 'transparent', minHeight: 570, position: 'relative', ...sx}}>
          {children}
        </Box>
      )}
    </div>
  );
};

export default TabPanel;
